import  React , { Component }  from "react";
import "../components css/LedLight.css"
import i18n from "../i18n";
export default class LedLight extends Component{
    render(){
        return(
            <>
                <div className="LedLight"  style={i18n.language==='ar'?{right:"-40px"}:{left:"-40px"}}>
                    <div>
                        <img src="https://hassanaliabdelhamed.github.io/Palestinian/images/light.png"  alt="Led"/>
                    <div className="lightBeam">
                    </div>
                </div>
                </div>
            </>
        )
    }
}